// ==========================================
// UPDATED FREE SAMPLE VALIDATION
// ONLY ADDING NEW FUNCTIONALITY
// ==========================================

// max sample limit
var MAX_SAMPLE_PRODUCTS = 20;

// helper function for sample pack
function isSamplePackProduct(variantTitle) {
  if (!variantTitle) return false;

  return variantTitle.toLowerCase().includes('sample pack');
}

theme.alinga = theme.alinga || {};

theme.alinga.colorsamplefilter = () => {
  //free-samples-filter
  $('.filter-product-wrapper .filter-product-item').click(function () {
    var currentProduct = $(this).attr('id');
    var selectedProductEle = $(this);
    $('.filter-product-wrapper .filter-product-item').removeClass('is-active');
    $(this).toggleClass('is-active');
    $('.collection-sample-products .product-wrapper').hide();
    $('.collection-sample-products .product-wrapper.' + currentProduct).show();
    //for make disable material and colour if is not not avilable for selected product
    $(
      '.filter-material-wrapper .filter-material-item,.filter-colour-wrapper .filter-colour-item',
    ).each(function () {
      if (selectedProductEle.hasClass($(this).attr('id'))) {
        $(this).addClass('is-show');
      } else {
        $(this).removeClass('is-show');
        $(this).removeClass('is-active');
      }
    });
  });

  $('.filter-by-product .clear-product').click(function () {
    $('.filter-product-wrapper .filter-product-item').addClass('is-active');
    $('.collection-sample-products .product-wrapper').show();
    $(
      '.filter-material-wrapper .filter-material-item,.filter-colour-wrapper .filter-colour-item',
    ).addClass('is-show');
  });

  $('.filter-material-wrapper .filter-material-item').click(function () {
    var currentMaterial = $(this).attr('id');
    $('.filter-material-wrapper .filter-material-item').removeClass(
      'is-active',
    );
    $(this).toggleClass('is-active');
    $('.collection-sample-products .product-wrapper .variant-inner').hide();

    var currentColour;
    $('.filter-colour-wrapper .filter-colour-item').each(function () {
      if ($(this).hasClass('is-active')) {
        currentColour = $(this).attr('id');
      }
    });

    if (currentColour) {
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentColour +
          '.' +
          currentMaterial,
      ).show();
    } else {
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentMaterial,
      ).show();
    }
  });

  $('.filter-by-material .clear-material').click(function () {
    var currentColour;
    $('.filter-colour-wrapper .filter-colour-item').each(function () {
      if ($(this).hasClass('is-active')) {
        currentColour = $(this).attr('id');
      }
    });
    $('.filter-material-wrapper .filter-material-item').removeClass(
      'is-active',
    );
    if (currentColour) {
      $('.collection-sample-products .product-wrapper .variant-inner').hide();
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentColour,
      ).show();
    } else {
      $('.collection-sample-products .product-wrapper .variant-inner').show();
    }
  });

  $('.filter-colour-wrapper .filter-colour-item').click(function () {
    var currentColour = $(this).attr('id');
    $('.filter-colour-wrapper .filter-colour-item').removeClass('is-active');
    $(this).toggleClass('is-active');
    $('.collection-sample-products .product-wrapper .variant-inner').hide();

    var currentMaterial;
    $('.filter-material-wrapper .filter-material-item').each(function () {
      if ($(this).hasClass('is-active')) {
        currentMaterial = $(this).attr('id');
      }
    });

    if (currentMaterial) {
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentMaterial +
          '.' +
          currentColour,
      ).show();
    } else {
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentColour,
      ).show();
    }
  });

  $('.filter-by-colour .clear-colour').click(function () {
    var currentMaterial;
    $('.filter-material-wrapper .filter-material-item').each(function () {
      if ($(this).hasClass('is-active')) {
        currentMaterial = $(this).attr('id');
      }
    });
    $('.filter-colour-wrapper .filter-colour-item').removeClass('is-active');
    if (currentMaterial) {
      $('.collection-sample-products .product-wrapper .variant-inner').hide();
      $(
        '.collection-sample-products .product-wrapper .variant-inner.' +
          currentMaterial,
      ).show();
    } else {
      $('.collection-sample-products .product-wrapper .variant-inner').show();
    }
  });

}

theme.alinga.zoomimage = () => {
  $(function () {
       var img = $('.zoom-varaint-image img'),
           imgshow = $('#imgshow'),
           bgpopup = $('.cc-popup-background'),
           overly = $('#over'),
           close = $('#close');
           img.on('click', function () {
           overly.show();
           imgshow.attr('src', $(this).attr('src'));
           close.click(function(){
             overly.hide()
           ;})
           bgpopup.click(function(){
             overly.hide()
           ;})
     ;})
  ;});

    $(function () {
       var img = $('.collection-gallery-popup img'),
           imgshow = $('#imgshow'),
           bgpopup = $('.cc-popup-background'),
           overly = $('#over'),
           close = $('#close');
           img.on('click', function () {
           overly.show();
           imgshow.attr('src', $(this).attr('src'));
           close.click(function(){
             overly.hide()
           ;})
           bgpopup.click(function(){
             overly.hide()
           ;})
     ;})
  ;});
}

theme.alinga.parallaxeffect = () => {
  $(window).scroll(function(){
    $('.parallax-image').each(function(){
      if ($(this).offset().top < $(window).scrollTop()) {
        var difference = $(window).scrollTop() - $(this).offset().top;
        var half = (difference / 2) + 'px';
  
        $(this).find('img').css('top', half);
      } else {
        $(this).find('img').css('top', '0');
      }
    });
  });
}

function showSampleErrorMessage(element, message) {

  // remove old messages
  $('.sample-error-message').remove();

  // append new message
  $(element)
    .closest('.variant-inner-block')
    .append(
      '<div class="sample-error-message">' + message + '</div>'
    );

  // auto remove after 4 sec
  setTimeout(() => {
    $('.sample-error-message').fadeOut(300, function () {
      $(this).remove();
    });
  }, 4000);
}

// add disable class if sample product is in the cart
theme.alinga.removeFreeSample = () => {
  let removeFreeSampleCart = document.querySelectorAll('.action-content-wrappper .action-wrapper .collectioncart');
  removeFreeSampleCart.forEach(item => {
    item.addEventListener('click', async function(evt) {
      let cartDrawarItem = await fetch('/cart.js').then(response =>
        response.json(),
      ); 
      let freeSamplesCart = [...cartDrawarItem.items];
      oldFreeSamplesCart = freeSamplesCart.map((item)=>{
        let itemInfo = { "variant_id": item.variant_id,
            "product_type": item.product_type,
            "variant_title": item.variant_title,
            "quantity": item.quantity
            }
        return itemInfo;
      });
  
      var currentVariantId = $(this)
        .closest('.action-wrapper')
        .attr('data-variant-id');

      var currentProductType = $(this)
        .closest('.action-wrapper')
        .attr('data-product-type');

      var currentVariantTitle = $(this)
        .closest('.action-wrapper')
        .attr('data-variant-title');
      var alreadyInCart = false;
      var FreeProductCount = 0;

      var samplePackCount = 0;
      var hasSamplePackInCart = false;

      var currentIsSamplePack = isSamplePackProduct(currentVariantTitle);
  
      for (var i = 0; i < oldFreeSamplesCart.length; i++) {

        var cartItem = oldFreeSamplesCart[i];

        // count normal sample products
        if (cartItem.product_type === 'Colour Sample') {
          FreeProductCount += cartItem.quantity;
        }

        // detect sample pack
        if (isSamplePackProduct(cartItem.variant_title)) {
          hasSamplePackInCart = true;
          samplePackCount += cartItem.quantity;
        }

        // duplicate variant
        if (cartItem.variant_id == currentVariantId) {
          alreadyInCart = true;
        }
      }
      
      // sample limit validation
      if (
        currentProductType === 'Colour Sample' &&
        FreeProductCount >= MAX_SAMPLE_PRODUCTS
      ) {

        $('.action-content-wrappper .action-wrapper .collectioncart')
          .addClass('disable');

        showSampleErrorMessage(
          this,
          'You can add a maximum of 20 samples to your cart.'
        );
        return;
      }

      // only 1 sample pack allowed
      if (
        currentIsSamplePack &&
        samplePackCount >= 1
      ) {
        showSampleErrorMessage(
          this,
          'You already have a sample pack in your cart. To mix & match, remove the pack and pick your favourite colour samples.'
        );
        return;
      }

      // sample pack blocks sample products
      if (
        currentProductType === 'Colour Sample' &&
        hasSamplePackInCart
      ) {
        showSampleErrorMessage(
          this,
          'You already have a sample pack in your cart. To mix & match, remove the pack and pick your favourite colour samples.'
        );
        return;
      }

      // sample products block sample pack
      if (
        currentIsSamplePack &&
        FreeProductCount > 0
      ) {
        showSampleErrorMessage(
          this,
          'Prefer a sample pack? Simply clear your cart from individual samples, then pop the pack in!'
        );
        return;
      }
      
      // already added
      if (alreadyInCart) {
        return;
      }

      // add product
      if (!evt.detail || evt.detail === 1) {
        addItem($(this).attr('id'));
        $(this).addClass('disable');
      }
    })
  })
}
//if freesample variant already in cart make it disable onload
theme.alinga.windowOnLoad = () => {
  window.addEventListener("load", (event) => {
    // console.log('page loaded');
    let currentVariants = [];
    const handleFreeSamplesVariants = () => {
      $('.variant-wrapper .variant-inner').each(function () {
        currentVariants.push(parseInt($(this).attr('id')));
      });
    };
    handleFreeSamplesVariants();
    for (var i = 0; i < window.themeCart.cart.items.length; i++) {
      if (currentVariants.includes(window.themeCart.cart.items[i].variant_id)) {
          handleDOMVariants(window.themeCart.cart.items[i].variant_id);
      }
    }
    function handleDOMVariants(checkVariant) {
      var FreeProductCount = 0;
  
      for (var i = 0; i < window.oldFreeSamplesCart.length; i++) {
        if (window.oldFreeSamplesCart[i].product_type === 'Colour Sample') {
          FreeProductCount += window.oldFreeSamplesCart[i].quantity;
        }
      }
      if (FreeProductCount >= MAX_SAMPLE_PRODUCTS) {
        console.log('freeproductcount');
        $('.variant-wrapper .variant-inner').each(function () {
            $(this)
              .find('.action-content-wrappper .action-wrapper .collectioncart')
              .addClass('disable');
        });
      }else{
        $('.variant-wrapper .variant-inner').each(function () {
            $(this)
              .find('.action-content-wrappper .action-wrapper .collectioncart-'+checkVariant)
              .addClass('disable');
        });
      }
    }
    // console.log(handleDOMVariants);
  });
}

// function removeitemproduct(variant_id, currVarId){
//   //evt.preventDefault();
//   var currVarId = $('#Cart-Drawer .side-panel-content .remove').attr('data-variant-id');
//     $.ajax({
//         type: 'POST',
//         url: '/cart/change.js',
//         dataType: 'json',
//         data: {
//             quantity: 0,
//             id: variant_id,
//             currentVariantId: currVarId
//         },
//        success: function (data) {
//           $.ajax({
//               type: 'GET',
//               dataType: 'json',
//               url: '/cart.json',
//               success: function(cart){   
//                   // Remove item
//                   $(this).parents('.ajaxcart__remove').remove();
//               }
//           });
//           fetch(`/cart.js`).then(res => res.json()).then(result => {
//               $('.thb-item-count').html(result.item_count);
//           });
//           $.ajax({
//               type: "GET",
//               url: '/cart',
//               dataType: "html",
//               success: function(data) {
//                   fetch(`/cart.json`).then(res => res.json()).then(response => {
//                       var cartData = $(data).find('.side-panel-content').html();
//                       $('.side-panel-content').html(cartData); 
//                   });
//               }
//            });
//           fetch(`/cart.json`).then(res => res.json()).then(result => {
//             let freeSamplesCartnew = [...result.items];
//             oldFreeSamplesCartnew = freeSamplesCartnew.map((item)=>{
//               let itemInfonew = { "variant_id": item.variant_id,
//                   "product_type": item.product_type
//                   }
//               return itemInfonew;
//             });
//             let freeSampleVariantsnew = [];
//             $('.action-content-wrappper .action-wrapper .collectioncart').removeClass('disable');
//             $('.variant-wrapper .variant-inner').each(function () {
//               freeSampleVariantsnew.push(parseInt($(this).attr('id')));
//             });
//             for (var i = 0; i < window.oldFreeSamplesCartnew.length; i++) {
//               if (
//                 freeSampleVariantsnew.includes(window.oldFreeSamplesCartnew[i].variant_id)
//               ) {
//                 handleaddedDOMVariants(window.oldFreeSamplesCartnew[i].variant_id);
//               }
//             }
//             function handleaddedDOMVariants(checkVariant) {
//               $('.variant-wrapper .variant-inner').each(function () {
//                 if (parseInt($(this).attr('id')) === checkVariant) {
//                   $(this)
//                     .find('.action-content-wrappper .action-wrapper .collectioncart')
//                     .addClass('disable');
//                 }
//               });
//             }
//           });
//           $('.action-content-wrappper .action-wrapper .collectioncart-'+variant_id).removeClass('disable');
//        }     
//   });
// }

theme.alinga.removeClassCartDrawer = () => {
  let cartDrawerRemove = document.querySelectorAll('#Cart-Drawer .side-panel-content .remove');
  cartDrawerRemove.forEach(item => {
    item.addEventListener('click',function(){ 
      var currentVariantId = $(this).attr('data-variant-id');
      var product_type = $(this).attr('data-product-type');
      const updatedRemoveData = {
        variant_id: parseInt(currentVariantId, 10),
        product_type: product_type,
      };
      updateFreeSamplesCartOnRemove(updatedRemoveData);
      var FreeProductCount = 0;

      for (var i = 0; i < window.oldFreeSamplesCart.length; i++) {
        if (window.oldFreeSamplesCart[i].product_type == 'Colour Sample') {
          FreeProductCount += window.oldFreeSamplesCart[i].quantity;
        }
      }

      if (FreeProductCount < MAX_SAMPLE_PRODUCTS) {
        let freeSampleVariants = [];
        $('.action-content-wrappper .action-wrapper .collectioncart').removeClass('disable');
        $('.variant-wrapper .variant-inner').each(function () {
          freeSampleVariants.push(parseInt($(this).attr('id')));
        });
        for (var i = 0; i < window.oldFreeSamplesCart.length; i++) {
          if (
            freeSampleVariants.includes(window.oldFreeSamplesCart[i].variant_id)
          ) {
            handleRemovedDOMVariants(window.oldFreeSamplesCart[i].variant_id);
          }
        }
        function handleRemovedDOMVariants(checkVariant) {
          $('.variant-wrapper .variant-inner').each(function () {
            if (parseInt($(this).attr('id')) === checkVariant) {
              $(this)
                .find('.action-content-wrappper .action-wrapper .collectioncart')
                .addClass('disable');
            }
          });
        }
      }
      function updateFreeSamplesCartOnRemove(data) {
        let newFreeSamplesObject;
        newFreeSamplesObject = window.oldFreeSamplesCart.filter(item => {
          return item.variant_id !== data.variant_id;
        });
        return (window.oldFreeSamplesCart = newFreeSamplesObject);
      }
    });
  });
}            

//remove addon products with main dynamic product
theme.alinga.cartDrawerATC = () => {

  let updateLineItemBtns = document.querySelectorAll('#Cart-Drawer .cart__remove--properties');
  let lineItems = [...updateLineItemBtns];
  lineItems.forEach(item => {
    item.addEventListener('click', async function(evt) {
      const currentUpi = item.getAttribute('data-cart-item-upi');
      evt.preventDefault();

      // check if there are multiple same upi in cart
      let cartDrawarItem = await fetch('/cart.js').then(response =>
        response.json(),
      );    
      let isMultipleUpiLineItem = cartDrawarItem.items.some(
        item => item.properties._upi === currentUpi,
      );

      let upiCount = cartDrawarItem.items.filter(
        item => item.properties._upi === currentUpi,
      ).length + 1;

      // if there is multiple upi in cart ... start another process of removing one by one
      if (isMultipleUpiLineItem) {
        handleChangeLineItem(upiCount, currentUpi)
      }
    });
  });

  async function handleChangeLineItem(upiCount, upi) {
    upiCount = upiCount - 1;

    if (upiCount > 0) {
      let cartItems = await fetch('/cart.js').then(response =>
        response.json(),
      );

      let sameUpiProductsLineIndex = cartItems.items.findIndex(item => {
        return item.properties._upi === upi 
      });

      let targetLineItem = sameUpiProductsLineIndex + 1;

      await changeLineItem(targetLineItem);

      await handleChangeLineItem(upiCount, upi);
    }else{
      $.ajax({
        type: "GET",
            url: '/cart',
            dataType: "html",
            success: function(data) {
              fetch(`/cart.json`).then(res => res.json()).then(response => {
                  $('.cart-drawer__empty-cart').remove();
                  var cartData = $(data).find('.side-panel-content').html();
                  $('.side-panel-content').html(cartData);
                  var cartAmount = $(data).find('.side-panel-footer').html();
                  $('.side-panel-footer').html(cartAmount);
                  $('.thb-item-count').html(response.item_count);
              });
            }
      });
    }
  }

  async function changeLineItem(removeProductLineIndex) {

      let data = {
        line: removeProductLineIndex,
        quantity: 0,
      };

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
          return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }   

}

   //free sample addtocart
function addItem(form_id) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $('#'+form_id).serialize(),
    dataType: 'json',
    success: function (result) {
      fetch(`/cart.js`).then(res => res.json()).then(result => {
        $('.thb-item-count').html(result.item_count);
      });
      $.ajax({
            type: "GET",
            url: '/cart',
            dataType: "html",
            success: function(data) {
              fetch(`/cart.json`).then(res => res.json()).then(response => {
                  $('.cart-drawer__empty-cart').remove();
                  var cartData = $(data).find('.side-panel-content').html();
                  $('.side-panel-content').html(cartData);
                  var cartAmount = $(data).find('.side-panel-footer').html();
                  $('.side-panel-footer').html(cartAmount);
                  $("body").addClass('open-cc');
                $('#Cart-Drawer').addClass('active');
              });
            }
        });
    },
  });
}
  

document.addEventListener('DOMContentLoaded', () => {
  theme.alinga.colorsamplefilter();
  theme.alinga.removeFreeSample();
  theme.alinga.windowOnLoad();
  theme.alinga.removeClassCartDrawer();
  theme.alinga.zoomimage();
  theme.alinga.parallaxeffect();
  theme.alinga.cartDrawerATC();
});

if (window.innerWidth >= 768) {
  const setRowHeight = ($elements) => {
  let rows = {};

  // Group elements by their row index
  $elements.forEach(element => {
    let rowIndex = Math.floor(element.offsetTop / element.offsetHeight);
    if (!rows[rowIndex]) {
      rows[rowIndex] = [];
    }
    rows[rowIndex].push(element);
  });

  // For each row, find the maximum height for each type of element
  Object.values(rows).forEach(row => {
    let maxHeights = {
      'pdp-grid-content': 0,
      'pdp-grid-subheading': 0,
      'pdp-dec-bullet': 0
    };

    row.forEach(element => {
      let elementsToMeasure = {
        'pdp-grid-content': element.querySelector('.pdp-grid-content'),
        'pdp-grid-subheading': element.querySelector('.pdp-grid-subheading'),
        'pdp-dec-bullet': element.querySelector('.pdp-dec-bullet')
      };

      Object.keys(elementsToMeasure).forEach(key => {
        if (elementsToMeasure[key]) {
          maxHeights[key] = Math.max(maxHeights[key], elementsToMeasure[key].offsetHeight);
        }
      });
    });

    // Set the height for each type of element in the row
    row.forEach(element => {
      Object.keys(maxHeights).forEach(key => {
        let elementToAdjust = element.querySelector(`.${key}`);
        if (elementToAdjust) {
          elementToAdjust.style.height = `${maxHeights[key]}px`;
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  let elements = document.querySelectorAll('.gallery__item');
  setRowHeight(elements);
});

}


let playBgVideo = document.querySelectorAll('.first-video-metafield .video-lightbox-modal__button');
playBgVideo.forEach(item => {
  item.addEventListener('click',function(){
      item.closest('.install-background-video').classList.add('is-active');
      var vid = item.parentElement.nextSibling;
      let vid1 = vid.querySelector('p span .myVideo');
      vid1.play();
  });
});

let mainVideo = document.querySelector('.pdp-video-metafield .video-lightbox-modal__button');
if(mainVideo){
mainVideo.addEventListener('click',function(){
      mainVideo.closest('video-metafield.first-background-video').classList.add('is-active');
      var mainvideo = mainVideo.parentElement.nextSibling;
      let pvideo = mainvideo.querySelector('p span .myVideo');
      if(pvideo){
        pvideo.play();
      }
});
}

let firstvideo = document.querySelector('.second-video-metafield .video-lightbox-modal__button');
if(firstvideo){
firstvideo.addEventListener('click',function(){
      firstvideo.closest('video-metafield.second-background-video').classList.add('is-active');
      var firstVideo = firstvideo.parentElement.nextSibling;
      let fvideo = firstVideo.querySelector('p span .myVideo');
      if(fvideo){
        fvideo.play();
      }
});
}

let thirdVideo = document.querySelector('.third-video-metafield .video-lightbox-modal__button');
if(thirdVideo){
thirdVideo.addEventListener('click',function(){
      thirdVideo.closest('video-metafield.third-background-video').classList.add('is-active');
      var thirdvideo = thirdVideo.parentElement.nextSibling;
      let tvideo = thirdvideo.querySelector('p span .myVideo');
      if(tvideo){
        tvideo.play();
      }
});
}

// $('.pdp-video-metafield .video-lightbox-modal__button').click(function () {	
//   $('video-metafield.first-background-video').addClass('is-active');	
// });

// $('.second-video-metafield .video-lightbox-modal__button').click(function () {	
//   $('video-metafield.second-background-video').addClass('is-active');	
// });
// $('.third-video-metafield .video-lightbox-modal__button').click(function () {	
//   $('video-metafield.third-background-video').addClass('is-active');	
// });


// Add order note in slide cart
$(document).ready(function(){
  // console.log("Ready function call");
  $(".side-panel-footer .order-note-toggle").click(function(){
    // console.log("Add order note active");
    $(".order-note-toggle__content").toggleClass("hidden unhidden");
  });
});
$(document).ready(function(){
  $('.mobile-view-back-btn-wrapper').click(function () {
    $('.mobile-menu .sub-menu .menu-item-has-children').removeClass('active');
  });
});
$(document).on("click", ".side-panel-footer .order-note-toggle", function(){
  $(".order-note-toggle__content").addClass("active");
});
$(document).on("click", ".order-note-toggle__content.active .button.full", function(){
  $(".order-note-toggle__content").removeClass("active");
});
// Add enable class in mobile menu
$(document).ready(function() {
  // Add click event listener to each div inside li tags
  $(".menu-third-item .link-container").on("click", function() {
    // Remove "active" class from all li tags
     $(".menu-third-item").removeClass("enable");

    // Add "active" class to the parent li tag
    $(this).parent(".menu-third-item").addClass("enable");
  });
});
document.querySelectorAll('.product-form__input--color label').forEach(label => {
    label.addEventListener('mouseenter', function () {
        let tooltip = this.querySelector('span');

        if (tooltip) {
            let rect = tooltip.getBoundingClientRect();

            // Remove any existing classes
            tooltip.classList.remove('tooltip-left', 'tooltip-right');

            // If tooltip overflows left
            if (rect.left < 0) {
                tooltip.classList.add('tooltip-left');
            }

            // If tooltip overflows right
            if (rect.right > window.innerWidth) {
                tooltip.classList.add('tooltip-right');
            }
        }
    });

    label.addEventListener('mouseleave', function () {
        let tooltip = this.querySelector('span');
        if (tooltip) {
            tooltip.classList.remove('tooltip-left', 'tooltip-right');
        }
    });
});

$(document).ready(function() {
// Swiper: Slider
    new Swiper('#MultiBlockSlider', {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1920: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 1,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 10
            }
        }
    }); 
});

function replacePvcTitle(element) {
  const text = element.textContent.trim();
  switch (text) {
    case 'Venetian PVC Corded':
      element.textContent = 'Venetian Fauxwood Corded';
      break;
    case 'Venetian PVC Cordless':
      element.textContent = 'Venetian Fauxwood Cordless';
      break;
  }
}

function pvcTitleChangeWhenReady() {
  const observer = new MutationObserver(() => {
    const pvc_titles = document.querySelectorAll('.collection-react-page .kyojiS');
    pvc_titles.forEach(el => replacePvcTitle(el));
  });

  const startObserving = () => {
    const targetNode = document.querySelector('.collection-react-page');
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        characterData: true,
      });

      // Initial replacement
      const pvc_titles = document.querySelectorAll('.collection-react-page .kyojiS');
      pvc_titles.forEach(el => replacePvcTitle(el));
    } else {
      // Retry if .collection-react-page not ready yet
      setTimeout(startObserving, 300);
    }
  };

  startObserving();
}

document.addEventListener('DOMContentLoaded', pvcTitleChangeWhenReady);
